import { createContext, useContext } from 'react';
import type { ThemeConfig } from '@/types';
import type { ThemeName } from '@/lib/themes';

export interface ThemeContextType {
  theme: ThemeConfig | null;
  isLoading: boolean;
  themeName: ThemeName;
  setThemeName: (themeName: ThemeName) => void;
}

export const ThemeContext = createContext<ThemeContextType>({
  theme: null,
  isLoading: false,
  themeName: 'Solitude',
  setThemeName: () => {},
});

export function useThemeContext() {
  return useContext(ThemeContext);
}
